<template>
  <div class="field-input-radio">
    <div class="input-group">
      <div class="btn-group btn-group-toggle smaller-font-content input-product-select" data-toggle="buttons">
        <v-select
          :name="'typeahead_' + fieldData.field_name"
          :id="'typeahead_' + fieldData.field_name"
          :disabled ="!!(showDisabled())"
          v-bind:class="{'std-width form-control': false, 'error': errors.has(fieldData.field_name) || fieldData.has_error }"
          v-model="selectChosen"
          :options="selectOptions"
          :maxHeight="getDropdownHeight()"
          placeholder="Select One"
          size="auto">
          <template slot="option" slot-scope="option">
            <i class="fas" :class="option.icon" /> <strong>{{ option.label }}</strong>
          </template>
        </v-select>

        <input
          v-show="false"
          :name="fieldData.field_name"
          :id="fieldData.field_name"
          :disabled ="!!(showDisabled())"
          type="text"
          class="form-control"
          :maxlength="fieldData.max_length"
          v-model="fieldData.field_value"
          v-validate="field_rules">
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import { inputFieldMixin } from '../../mixins/inputFieldMixin';

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData', 'inputType', 'sendPostRule'],
  mixins: [inputFieldMixin],
  data() {
    return {
      optionList: [], // Populated on `mounted` AND any time `fieldData.values` is updated (API request changes those values)
      optionChosen: { // Populated on `mounted` AND upon an option selected (triggered by the MODEL updating, aka `CHOSEN` aka `selectOptions`)
        label: '',
        value: '',
        thumbnail: '',
        description: '',
        icon: '',
      },
      iconDictionary: {
        auto: 'fa-car',
        home: 'fa-home',
        condo: 'fa-hotel',
        renters: 'fa-building',
      },
    };
  },
  methods: {
    /* eslint consistent-return: */
    getDropdownHeight() {
      if (this.fieldData.field_type === 'select_medium_bottom') {
        return '90px';
      } else if (this.fieldData.field_type === 'select_large_bottom' || this.fieldData.field_type === 'select_long_bottom') {
        return '170px';
      }
    },
    // TODO: Abstract into helper class
    /**
     * The validation message overlaps the interactive form element, so it is cleared
     * once the components containing the element is clicked.
     */
    clearMessages() {
      this.fieldData.has_error = false; // Reset API errors to false upon any interaction
      this.errors.remove(this.fieldData.field_name); // Temporarily hide the validation message
    },
  },
  mounted() {
    const typeArr = this.fieldData.field_type.split('_');
    if (typeArr[0] && typeArr[0] === 'select') {
      this.selectOptions = this.fieldData.values;
    }
    this.optionChosen = this.optionList[0];
  },
  computed: {
    /* eslint prefer-const: */
    /* eslint no-undef:  */
    /* eslint no-unused-vars: */
    selectOptions: { // aka OPTIONS
      get: function () {
        return this.optionList;
      },
      set: function (value) {
        this.optionList = []; // Reset list to empty
        const improperOptionList = this.fieldData.values;
        improperOptionList.forEach((val) => {
          const properOptionItem = {
            label: val.display_value,
            value: val.internal_value,
            icon: this.iconDictionary[val.internal_value],
          };

          // Select the option that matches the API data's value
          if (properOptionItem.value === this.fieldData.field_value) {
            this.optionChosen = properOptionItem;
          }
          this.optionList.push(properOptionItem);
        });
      },
    },
    selectChosen: { // aka CHOSEN
    /* eslint no-param-reassign:  */
    /* eslint object-shorthand:  */
    /* eslint func-names: [0] */
      get: function () {
        if (this.optionChosen.value === '') {
          return false;
        }
        return this.optionChosen;
      },
      set: function (value = null) {
        if (!value) {
          value = {
            label: '',
            value: '',
          };
        }

        const isNewValue = (this.fieldData.field_value !== value.value);
        this.optionChosen = value;
        this.fieldData.field_value = value.value;

        // Send API request
        if (isNewValue && this.apiRule.present && this.apiRule.type === 'onchange') {
          this.postRule(this.fieldData.field_value, this.fieldData);
          this.fieldData.has_error = false; // Reset API errors to false upon any interaction
        }
      },
    },
    formdataValues: { // Needed to watch when `this.formdata.values` is updated
      get: function () {
        return this.fieldData.values;
      },
      set: function (value) {
        this.formdata.values = value;
      },
    },
  },
  components: {
    vSelect,
  },
  watch: {
    'fieldData.field_value': function fieldValue() {
      this.clearMessages();
    },
    formdataValues: function (newValue, oldValue) {
      this.optionList = []; // Reset list to empty
      this.optionChosen = {
        label: '',
        value: '',
        icon: '',
      };

      let improperOptionList = this.fieldData.values;

      improperOptionList.forEach((val) => {
        let properOptionItem = {
          label: val.display_value,
          value: val.internal_value,
          icon: this.iconDictionary[val.internal_value],
        };

        // Select the option that matches the API data's value
        if (properOptionItem.value === this.fieldData.field_value) {
          this.optionChosen = properOptionItem;
        }

        this.optionList.push(properOptionItem);
      });
    },
    /**
     * When visible updates from false -> true, set up Places Autocomplete, if necessary
     */
    is_visible: function (newValue, oldValue) {
      if (!oldValue && newValue) {
        this.places_autocomplete_init();
      }
    },
  },
};
</script>
<style scoped>
.selected-tag {
  max-width: 300px !important;
  overflow: hidden !important;
  white-space: nowrap !important;
}
.v-select .vs__actions .clear,
.v-select .dropdown-toggle::after {
  display: none !important;
}
.v-select .dropdown-toggle .clear { visibility: hidden !important; }

.v-select .vs__actions .clear,
.v-select .dropdown-toggle .clear::after {
  display: none !important;
}
.v-select .vs__actions .clear span{
  display: none !important;
}
.v-select .dropdown-toggle .clear { visibility: hidden !important; }
.hidden-field {
  display: none;
}

/**V-SELECT: STYLING OVERRIDES**/
.dropdown {
  display: inline-block;
}
  .v-select .dropdown-toggle {
    background: #FFFFFF;
    border: 1px solid #CCCCCC;
  }
  .v-select.disabled .dropdown-toggle,
  .v-select.disabled .dropdown-toggle input,
  .v-select.disabled .dropdown-toggle .selected-tag {
    pointer-events: none !important;
    color: #333333 !important;
    cursor: not-allowed !important;
    background-color: #EEEEEE;
  }
    .form-control::placeholder {
      color: #999999 !important;
    }

  .input-product-select .v-select .vs__selected-options {
    position: relative;
    width: auto !important;
    height: 21px;
    min-width: 100px;
    padding: 0 10px;
    flex-basis: initial;
    flex-grow: initial;
    flex-wrap: initial;
    flex: 1 0 auto;
    -ms-flex: 1 0 auto;
  }
    /**Input**/
    .v-select input[type=search],
    .v-select input[type=search]:focus {
      height: auto;
      padding: 0;
      border: none;
    }
    .v-select.open input[type=search] {
      position: absolute;
      width: auto !important;
    }
    /**Selected Value**/
    .v-select .selected-tag {
      position: relative !important;
      margin: 4px 0 0;
      padding: 0;
    }

    /**Toggle Arrow Icon**/
    .v-select .vs__actions {
      padding: 0 5px;
    }
      .v-select .open-indicator{
        width: 20px;
        background: none !important;
      }
      .v-select .open-indicator:before {
        margin: 0 auto;
      }
      .v-select.open .open-indicator:before {
        margin: 10px auto 0;
      }

  /**Dropdown Options**/
  .input-product-select .dropdown-menu {
    width: auto !important;
    padding: 0 0 0.25rem !important;
    overflow-x: hidden;
    overflow-y: auto !important;
    font-size: 0.75rem;
    border-left: 1px solid #CCCCCC !important;
    border-right: 1px solid #CCCCCC !important;
    border-bottom: 1px solid #CCCCCC !important;
    border-top: none !important;
  }
    .dropdown-menu li>a {
      padding: 3px 20px 3px 10px !important;
    }
  img.select-thumbnail {
    width: 50px;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
  }
  p.select-description {
    white-space: normal;
  }
/*
  TODO: Add IE/Edge support by implementing the `label.btn` styles via JavaScript. Bootstrap adds classes
  'focus' and 'active' to the radio <input>'s "closest" element, which happens to be the <label>.
  See https://github.com/twbs/bootstrap/blob/7c7a1706c348fcb5290a63d9249e0c8e4b6ebbcf/js/src/button.js#L153 .
*/
label.btn:focus-within {
  color: #fff;
  background-color: #001a33;
  border-color: #001326;
  z-index: 1;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
  box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
  box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
}

select.form-control {
    height: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/interactive/InputProductSelect.vue?78eb879e